"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _utils = require("@/utils");
var _onboardingStatus = require("@/utils/onboardingStatus");
var _livenessDossierStatus = require("@/utils/livenessDossierStatus");
var _default2 = exports.default = {
  name: 'CardDossie',
  components: {
    Card: _components.Card
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    validation: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    currentFaceAttempt: function currentFaceAttempt() {
      return (0, _livenessDossierStatus.getLatestFaceAttempt)(this.validation);
    },
    documents: function documents() {
      var _this$validation;
      return ((_this$validation = this.validation) === null || _this$validation === void 0 ? void 0 : _this$validation.documents) || null;
    },
    scoreFinal: function scoreFinal() {
      var _this$validation2, _scoreEntry$valor;
      var scoreEntries = Array.isArray((_this$validation2 = this.validation) === null || _this$validation2 === void 0 ? void 0 : _this$validation2.dataValidaScore) ? this.validation.dataValidaScore : [];
      var scoreEntry = scoreEntries.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.nome) === 'resultado-score-datatrust';
      });
      return (_scoreEntry$valor = scoreEntry === null || scoreEntry === void 0 ? void 0 : scoreEntry.valor) !== null && _scoreEntry$valor !== void 0 ? _scoreEntry$valor : null;
    },
    reasonDocument: function reasonDocument() {
      var _this$documents;
      var documentoscopia = (_this$documents = this.documents) === null || _this$documents === void 0 ? void 0 : _this$documents.documentoscopia;
      return documentoscopia === null || documentoscopia === undefined ? '--' : _utils.StatusDocument.fromString(String(documentoscopia));
    },
    processStatusKey: function processStatusKey() {
      var _this$validation3;
      return (0, _onboardingStatus.getOnboardingStatusKey)((_this$validation3 = this.validation) === null || _this$validation3 === void 0 ? void 0 : _this$validation3.status);
    },
    processStatusLabel: function processStatusLabel() {
      var _this$validation4, _this$validation5;
      return (0, _onboardingStatus.getOnboardingStatusLabel)((_this$validation4 = this.validation) === null || _this$validation4 === void 0 ? void 0 : _this$validation4.status, ((_this$validation5 = this.validation) === null || _this$validation5 === void 0 ? void 0 : _this$validation5.status) || '--');
    },
    dossierDecision: function dossierDecision() {
      return (0, _livenessDossierStatus.getLivenessDossierDecision)(this.validation, this.processStatusKey);
    },
    dossierDecisionLabel: function dossierDecisionLabel() {
      return this.dossierDecision.label;
    },
    validationFace: function validationFace() {
      var _this$currentFaceAtte;
      var selfie = (_this$currentFaceAtte = this.currentFaceAttempt) === null || _this$currentFaceAtte === void 0 ? void 0 : _this$currentFaceAtte.selfie;
      if (typeof selfie === 'string' && selfie) {
        return selfie.includes('http') || selfie.startsWith('data:') ? selfie : "data:image/png;base64,".concat(selfie);
      }
      return null;
    },
    facematchAccuracy: function facematchAccuracy() {
      var _this$currentFaceAtte2;
      var facematch = Number((_this$currentFaceAtte2 = this.currentFaceAttempt) === null || _this$currentFaceAtte2 === void 0 ? void 0 : _this$currentFaceAtte2.facematch);
      if (Number.isNaN(facematch)) {
        return '--';
      }
      if (facematch <= -90) {
        return "".concat(facematch, "% ").concat(_utils.FacematchAccuracy.HIGH);
      } else if (facematch > -90 && facematch <= -10) {
        return "".concat(facematch, "% ").concat(_utils.FacematchAccuracy.MEDIUM);
      } else if (facematch > -10 && facematch <= 0) {
        return "".concat(facematch, "% ").concat(_utils.FacematchAccuracy.NEUTRAL);
      } else if (facematch > 0 && facematch <= 10) {
        return "".concat(facematch, "% ").concat(_utils.FacematchAccuracy.MEDIUM_CONFIDENCE);
      } else if (facematch > 10 && facematch < 95) {
        return "".concat(facematch, "% ").concat(_utils.FacematchAccuracy.HIGH_CONFIDENCE);
      } else if (facematch >= 95) {
        return "".concat(facematch, "% ").concat(_utils.FacematchAccuracy.TOTAL_CONFIDENCE);
      }
      return '--';
    },
    summaryStatus: function summaryStatus() {
      if (this.processStatusKey === 'canceled') {
        return {
          title: 'Processo cancelado',
          description: 'A jornada foi interrompida antes da conclusão, então o detalhamento permanece disponível apenas para consulta do histórico e das evidências já geradas.',
          tagLabel: 'Processo Cancelado',
          tagClass: 'is-danger',
          icon: 'close-circle'
        };
      }
      if (this.dossierDecision.key === _livenessDossierStatus.LIVENESS_DOSSIER_DECISION.approved.key) {
        return {
          title: 'Processo aprovado automaticamente',
          description: 'Os sinais principais do fluxo convergiram para um resultado positivo, sem necessidade de ressalva automática.',
          tagLabel: 'Aprovado',
          tagClass: 'is-success',
          icon: 'check-circle'
        };
      }
      if (this.dossierDecision.key === _livenessDossierStatus.LIVENESS_DOSSIER_DECISION.rejected.key) {
        return {
          title: 'Processo reprovado automaticamente',
          description: 'A análise consolidada identificou um ou mais pontos críticos no fluxo de validação.',
          tagLabel: 'Reprovado',
          tagClass: 'is-danger',
          icon: 'alert-circle'
        };
      }
      return {
        title: 'Processo em análise',
        description: 'Uma ou mais etapas ainda não possuem resultado final suficiente para aprovar ou reprovar o processo.',
        tagLabel: this.dossierDecisionLabel,
        tagClass: 'is-warning',
        icon: 'clock-outline'
      };
    },
    dossieHighlights: function dossieHighlights() {
      var _this$currentFaceAtte3, _this$currentFaceAtte4, _this$currentFaceAtte5, _this$documents2, _this$currentFaceAtte6;
      var hasFacematch = ((_this$currentFaceAtte3 = this.currentFaceAttempt) === null || _this$currentFaceAtte3 === void 0 ? void 0 : _this$currentFaceAtte3.facematch) !== null && ((_this$currentFaceAtte4 = this.currentFaceAttempt) === null || _this$currentFaceAtte4 === void 0 ? void 0 : _this$currentFaceAtte4.facematch) !== undefined && ((_this$currentFaceAtte5 = this.currentFaceAttempt) === null || _this$currentFaceAtte5 === void 0 ? void 0 : _this$currentFaceAtte5.facematch) !== '';
      var documentoscopia = (_this$documents2 = this.documents) === null || _this$documents2 === void 0 ? void 0 : _this$documents2.documentoscopia;
      var hasDocumentoscopia = documentoscopia !== null && documentoscopia !== undefined && documentoscopia !== '';
      var hasSpoofing = typeof ((_this$currentFaceAtte6 = this.currentFaceAttempt) === null || _this$currentFaceAtte6 === void 0 ? void 0 : _this$currentFaceAtte6.spoof) === 'boolean';
      return [hasSpoofing ? {
        key: 'spoofing',
        label: 'Spoofing / Liveness',
        text: this.currentFaceAttempt.spoof ? 'Detectado' : 'Não detectado',
        tag: this.currentFaceAttempt.spoof ? 'Alerta' : 'Validado',
        tone: this.currentFaceAttempt.spoof ? 'danger' : 'success',
        icon: 'shield-check',
        helper: 'Indica a leitura consolidada de presença e prova de vida.'
      } : null, hasFacematch ? {
        key: 'facematch',
        label: 'FaceMatch',
        text: this.facematchAccuracy,
        tag: 'Confiança',
        tone: Number(this.currentFaceAttempt.facematch) < 0 ? 'danger' : Number(this.currentFaceAttempt.facematch) === 0 ? 'warning' : 'success',
        icon: 'account-check',
        helper: 'Representa o nível de confiança na correspondência facial.'
      } : null, hasDocumentoscopia ? {
        key: 'documentoscopia',
        label: 'Análise de Documentos',
        text: this.reasonDocument,
        tag: 'Documentos',
        tone: (0, _livenessDossierStatus.getDocumentValidationOutcome)(documentoscopia) === 'approved' ? 'success' : 'danger',
        icon: 'file-check',
        helper: 'Resume a conclusão do processamento documental no dossiê.'
      } : null, this.scoreFinal !== null ? {
        key: 'score-final',
        label: 'Score Final',
        text: this.scoreFinal,
        tag: 'Risco',
        tone: 'info',
        icon: 'chart-line',
        helper: 'Score consolidado retornado no processo de validação.'
      } : null].filter(Boolean);
    }
  }
};